import { z } from "zod";

export const wagsAgentWidgetNameSchema = z.enum([
    "compatibility_score",
    "connectMcpAccount",
    "createBreedCards",
    "createDogCards",
    "createProviderClaimCard",
    "createProviderContactForm",
    "createQuickReplies",
    "createQuizInChat",
    "displayListingCards",
    "compute_breed_fit",
    "get_breed_info",
    "get_listing",
    "get_question_bank",
    "get_user_facts",
    "save_user_facts",
    "showDogPhotoPicker",
    "showFitSpotlight",
    "showListings",
]);

export const wagsAgentToolPartSchema = z.discriminatedUnion("state", [
    z.object({
        tool: z
            .string()
            .trim()
            .min(1)
            .regex(/^[A-Za-z0-9_.:-]+$/),
        toolCallId: z.string().min(1),
        state: z.literal("input-available"),
        input: z.json(),
    }),
    z.object({
        tool: z
            .string()
            .trim()
            .min(1)
            .regex(/^[A-Za-z0-9_.:-]+$/),
        toolCallId: z.string().min(1),
        state: z.literal("output-available"),
        input: z.json(),
        output: z.json(),
    }),
    z.object({
        tool: z
            .string()
            .trim()
            .min(1)
            .regex(/^[A-Za-z0-9_.:-]+$/),
        toolCallId: z.string().min(1),
        state: z.literal("output-error"),
        input: z.json(),
        errorText: z.string().min(1),
    }),
]);

export const wagsAgentToolPublicDataSchema = z
    .object({
        errorText: z.string().optional(),
        input: z.json().optional(),
        output: z.json().optional(),
        widget: z.string().min(1).optional(),
    })
    .loose();

export const wagsAgentMessageExternalSchema = z
    .object({
        inputId: z.string().min(1).optional(),
        metadata: z.record(z.string(), z.json()).optional(),
    })
    .loose();

export const wagsMessageMetadataSchema = z
    .object({
        conversationId: z.string().optional(),
        responseId: z.string().optional(),
        kitsMessageId: z.string().optional(),
        canonicalInputId: z.string().optional(),
        interrupted: z.boolean().optional(),
        createdAt: z.string().optional(),
        interaction: z
            .object({
                toolCallId: z.string(),
                widget: wagsAgentWidgetNameSchema,
                payload: z.json(),
            })
            .optional(),
        trigger: z
            .object({
                name: z.enum([
                    "first_save",
                    "overwhelm",
                    "dog_page",
                    "far_dog",
                ]),
            })
            .optional(),
    })
    .catchall(z.json());

export const wagsAgentToolCandidateSchema = z.object({
    tool: z.string(),
    toolCallId: z.string(),
    state: z.enum(["input-available", "output-available", "output-error"]),
    input: z.json(),
    output: z.json().optional(),
    errorText: z.string().optional(),
});
export type WagsAgentToolCandidate = z.infer<
    typeof wagsAgentToolCandidateSchema
>;
